<template>
  <div class="filial-settings-component">
    <div class="text-h2 mb-2" v-text="'Настройки'" />

    <template v-for="(v, i) in value">
      <v-row :key="`brsetrow-${i}`">
        <v-col cols="9">
          <v-text-field
            v-show="v.isDefaultValue"
            v-model="v.defaultValue"
            :label="v.name"
            outlined
            disabled
          />
          <v-text-field
            v-show="!v.isDefaultValue"
            v-model="v.value"
            value=""
            :label="v.name"
            outlined
            :disabled="v.isDefaultValue"
            @input="emitInput"
          />
        </v-col>
        <v-col cols="3">
          <v-switch
            :input-value="!v.isDefaultValue"
            :label="`Переопределить`"
            @change="v.isDefaultValue=!v.isDefaultValue"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'FilialSettings',
    /* eslint-disable */
    props: ['value'],
    methods: {
      getInputValue (row) {
        return row.isDefaultValue ? row.defaultValue : row.value
      },
      onChangeSwitch (row) {
        row.isDefaultValue = !row.isDefaultValue
        this.emitInput()
      },

      emitInput () {
        this.$emit('input', this.value)
      },
    },
  }
</script>

<style scoped>

</style>
